import { environment } from '@app/../environments/environment';
import featureFlags from '@app/../feature-flags.json';
import config from '@rootConfig/config.json';
import { CodeRequestResultType } from '@shared/models/code-request-result.enum';
import { TenantResource } from '@shared/models/tenant.model';
import { COLORS } from '@shared/utils/colors';

export default {
  ...config,
  ...environment,
  featureFlags: featureFlags as Record<string, boolean | string | number>,
  tenants: {
    ALC: {
      id: 'ALC',
      name: 'Alcon',
    },
    ALM: {
      id: 'ALM',
      name: 'Almirall',
    },
    APG: {
      id: 'APG',
      name: 'Apotheco',
    },
    BHC: {
      id: 'BHC',
      name: 'Bausch Health',
    },
    DMO: {
      id: 'DMO',
      name: 'Demo',
    },
    GLD: {
      id: 'GLD',
      name: 'Galderma',
    },
    INCY: {
      id: 'INCY',
      name: 'Incyte',
    },
  },
  inventorySettingsTenants: ['ALM', 'INCY'],
  scorecardSettingsTenants: ['INCY'],
  upsUrl: 'https://www.ups.com/track?loc=en_US&tracknum=',
  fedexUrl: 'https://www.fedex.com/wtrk/track/?tracknumbers=',
  rulesPrograms: {
    ALC: [
      {
        id: 'copay-request',
        label: 'Copay Request Workflow',
        groupId: 'copay_base_data',
      },
    ],
    ALM: [
      {
        id: 'copay-request',
        label: 'Copay Request Workflow',
        groupId: 'copay_base_data',
      },
    ],
    APG: [
      {
        id: 'copay-request',
        label: 'Copay Request Workflow',
        groupId: 'copay_base_data',
      },
    ],
    BHC: [
      {
        id: 'copay-request',
        label: 'Copay Request Workflow',
        groupId: 'copay_base_data',
      },
    ],
    GLD: [
      {
        id: 'copay-request',
        label: 'Copay Request Workflow',
        groupId: 'copay_base_data',
      },
    ],
    INCY: [
      {
        id: 'copay-request',
        label: 'Copay Request Workflow',
        groupId: 'copay_base_data',
      },
    ],
    DMO: [
      {
        id: 'copay-request',
        label: 'Copay Request Workflow',
        groupId: 'copay_base_data',
      },
    ],
    SYSTEM: [
      {
        id: 'copay-request',
        label: 'Copay Request Workflow',
        groupId: 'copay_base_data',
      },
    ],
  },
  resources: <Record<string, TenantResource[]>>{
    ALC: [],
    ALM: [
      {
        category: 'ProgramInformation',
        name: 'Almirall Advantage Program Playbook',
        file_name: 'Almirall_Advantage_Program_Playbook.pptx',
      },
      {
        category: 'ProgramInformation',
        name: 'Medicare-Cash Pay Training',
        file_name: 'Medicare-Cash_Pay_Training.pptx',
      },
      {
        category: 'ProgramInformation',
        name: 'Copay Summary 2023 Table',
        file_name: 'Copay_Summary_2023_Table.pdf',
      },
    ],
    APG: [],
    BHC: [],
    DMO: [
      {
        category: 'ProgramInformation',
        name: 'Galderma Care Connect Summary',
        file_name: 'Galderma_Care_Connect_Summary_Table.pdf',
      },
    ],
    GLD: [
      {
        category: 'ProgramInformation',
        name: 'Galderma Care Connect Summary',
        file_name: 'Galderma_Care_Connect_Summary_Table.pdf',
      },
    ],
    INCY: [
      {
        category: 'ProgramInformation',
        name: 'Get To Know Your Bi-Weekly Replenishment Schedule for OPZELURA™',
        subtitle:
          'Incyte follows an order consolidation process that involves its batching of replenishment orders for OPZELURA™ based on several prior days of brightscrip-authorized claims in a single shipment.',
        button_label: 'Click here for Infographic',
        file_name: 'opzelura_replenishment_schedule.pdf',
        colors: {
          cardColor: COLORS.card.purpleBg,
          cardTitleColor: COLORS.white,
          cardSubtitleColor: COLORS.white,
          ctaButtonBgColor: COLORS.card.ctaCoral,
          ctaButtonLabelColor: COLORS.white,
        },
      },
      {
        category: 'ProgramInformation',
        name: 'Get to know your brightChart™ BETA',
        subtitle:
          'Let’s take a closer look at brightChart™ as a new means to gain visibility of your pharmacy’s activity in connection with manufacturer-sponsored copay programs.',
        button_label: 'Click here to Learn More',
        file_name: 'scorecard_incy_slide3.pdf',
        colors: {
          cardColor: COLORS.card.blackBg,
          cardTitleColor: COLORS.white,
          cardSubtitleColor: COLORS.white,
          ctaButtonBgColor: COLORS.card.ctaPink,
          ctaButtonLabelColor: COLORS.white,
        },
      },
    ],
  },
  claimResultTypes: [
    CodeRequestResultType.BrightLinkClicked,
    CodeRequestResultType.BrightLinkNoClicked,
    CodeRequestResultType.BrightLinkNotEligible,
    CodeRequestResultType.CashEligible,
    CodeRequestResultType.Duplicate,
    CodeRequestResultType.Paid,
    CodeRequestResultType.PaidEligible,
    CodeRequestResultType.Rejected,
    CodeRequestResultType.Reversed,
    CodeRequestResultType.PaPending,
  ],
  termsAndConditions: ['ALC', 'BHC', 'GLD', 'INCY'],
  claimOverrideRejectReasons: [
    {
      flag: 'flag_adj_quantity_dispensed_not_allowed',
      name: 'Quantity Dispensed Not Allowed',
      resultIds: ['rta:quantity-dispensed:not-allowed:failure'],
      rejectReasonMessages: [
        'OOPS! QUANTITY DISPENSED IS NOT ALLOWED',
        'OOPS! PLEASE CHECK YOUR QUANTITY DISPENSED',
        'Claim contains quantity dispensed out of range',
      ],
    },
    {
      flag: 'flag_govt_to_non_govt_change_on_patient_trend',
      oldFlag: 'flag_govt_to_non_govt_change_on_patient',
      name: 'Patient goes from Govt to non Govt',
      resultIds: ['rta:govt-to-non-govt:change-on-patient-trend:failure'],
      rejectId: '059',
    },
    {
      flag: 'flag_adj_dos_out_of_range',
      name: 'Date of service out of range',
      resultIds: ['rta:date-of-service:out-of-range:failure'],
      rejectId: '050',
    },
    {
      flag: 'flag_adj_therapeutic_duplicate',
      name: 'Therapeutic Duplicate',
      resultIds: ['rta:therapeutic-duplicate:same-pharmacy:failure', 'rta:therapeutic-duplicate:other-pharmacy:failure'],
    },
  ],
};
